import React from "react";
import Route from "./routes";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { store, persistor } from './modules/store';
import { PersistGate } from 'redux-persist/integration/react';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
function render() {
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Route />
       </PersistGate>
    </Provider>
  );
}

render();
store.subscribe(render);
